import * as TYPES from './_store/types';
import { usePageStore } from '@/store';

export function asyncData(store) {
    const pageStore = usePageStore(this.$pinia);
    let ps = [];
    this.listingDetail = this.listingDetail || {};
    ps.push(this.requestAgents());
    if (this.theme === 'column-agent') {
        ps.push(pageStore.getCompanyInfo());
    }
    const pageArr = [
        'listing-detail',
        'listing-detail-sold',
        'agent-detail',
        'blog-detail',
        'about-buyer',
        'about-seller',
        'profile'
    ];
    if (!this.formList.length && this.oldFormList && this.oldFormList.length) {
        this.formList = this.oldFormList.concat();
    }
    if (
        !this.hasSave &&
        this.oldFormList &&
        this.oldFormList.length &&
        pageArr.includes(this.pageKey)
    ) {
        ps.push(
            store[TYPES.GET_FORMREQUIRED]().then(data => {
                if (data.required !== undefined) {
                    let list = this.formList.map(item => {
                        if (item.name == 'phone') {
                            item.required = data.required;
                            if (data.validatePhone !== undefined) {
                                item.validatePhone = data.validatePhone;
                            }
                        }
                        return Object.assign({}, item);
                    });
                    this.formList = list;
                    store[TYPES.SET_FORMLISTSTATE](list);
                }
            })
        );
    }

    return Promise.all(ps);
}
